import React, { FunctionComponent } from 'react';
import { ChallengeUser } from '/src/domain/challenges/ChallengeUser';
import { SxProps, TextField } from '@mui/material';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import DateAdapter from '@mui/lab/AdapterDayjs';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

interface AdditionalProfileDataFieldsProps {
  userData: {
    firstName: string;
    lastName: string;
    birthDate: string;
  };
  profileData: AdditionalProfileData;
  setProfileData: React.Dispatch<React.SetStateAction<AdditionalProfileData>>;
  currentDateMsk: string;
}

const MAX_NAME_FIELD_LENGTH = 60;
export const DEFAULT_NAME = 'S10 runner';

export const defaultAdditionalProfileData = {
  firstName: {
    text: '',
    error: '',
  },
  lastName: {
    text: '',
    error: '',
  },
  birthDate: {
    text: '',
    error: '',
  },
};

export const getAdditionalProfileData = (currentUser?: ChallengeUser) => {
  const hasFirstName = Boolean(currentUser?.firstName?.trim().length);
  const firstName = hasFirstName ? 
    currentUser?.firstName?.trim() === DEFAULT_NAME ? "" : currentUser?.firstName?.trim()
    : currentUser?.lastName?.trim() === DEFAULT_NAME ? "" : currentUser?.lastName?.trim();
  const lastName = hasFirstName ? currentUser?.lastName?.trim() : "";
  return {
    ...defaultAdditionalProfileData,
    firstName: {
      text: firstName || '',
      error: '',
    },
    lastName: {
      text: lastName || '',
      error: '',
    },
    birthDate: {
      text: currentUser?.birthDate || '',
      error: '',
    },
  };
};

export type AdditionalProfileData = typeof defaultAdditionalProfileData;

export const AdditionalProfileDataFields: FunctionComponent<
  AdditionalProfileDataFieldsProps
> = ({ userData, profileData, setProfileData, currentDateMsk }) => {
  const { t } = useTranslation();

  const handleChangeProfileData = (
    value: string,
    type: 'firstName' | 'lastName' | 'birthDate',
  ) => {
    const newProfileData = { ...profileData };
    newProfileData[type] = {
      ...profileData[type],
      text: value,
    };

    if (type === 'firstName') {
      console.log(newProfileData)
      newProfileData['firstName'] = {
        ...newProfileData[type],
        error: (value.trim().length > MAX_NAME_FIELD_LENGTH || value.trim() === DEFAULT_NAME)
            ? 'invalidValue'
            : '',
      };
      console.log(newProfileData)
      console.log(value.trim())
      console.log(value.trim().length > MAX_NAME_FIELD_LENGTH)
      console.log(value === DEFAULT_NAME)
      console.log(value)
    }

    if (type === 'lastName') {
      newProfileData['lastName'] = {
        ...newProfileData[type],
        error: (value.trim().length > MAX_NAME_FIELD_LENGTH || value.trim() === DEFAULT_NAME)
            ? 'invalidValue'
            : '',
      };
    }

    setProfileData(newProfileData);
  };

  const handleChangeBirthDateError = (value: string | null) => {
    const newProfileData = { ...profileData };
    if (!value) {
      newProfileData['birthDate'].error = '';
    } else {
      newProfileData['birthDate'].error = 'invalidValue';
    }
    setProfileData(newProfileData);
  };

  return (
    <>
      <TextField
        sx={textFieldSx}
        required
        fullWidth
        name="firstname"
        type="text"
        value={profileData.firstName.text}
        onChange={(e) => handleChangeProfileData(e.target.value, 'firstName')}
        label={t('firstName')}
        error={!!profileData.firstName.error}
        helperText={t(profileData.firstName.error)}
      />
      <TextField
        sx={textFieldSx}
        fullWidth
        name="lastname"
        type="text"
        value={profileData.lastName.text}
        onChange={(e) => handleChangeProfileData(e.target.value, 'lastName')}
        label={t('lastName')}
        error={!!profileData.lastName.error}
        helperText={t(profileData.lastName.error)}
      />
      <LocalizationProvider dateAdapter={DateAdapter}>
        <DatePicker
          inputFormat="YYYY-MM-DD"
          mask="____-__-__"
          value={profileData.birthDate.text}
          onChange={(date) =>
            handleChangeProfileData(
              dayjs(date).format('YYYY-MM-DD'),
              'birthDate',
            )
          }
          onError={handleChangeBirthDateError}
          clearable
          clearText={t('reset')}
          cancelText={t('cancel')}
          maxDate={dayjs(currentDateMsk).subtract(7, 'year')}
          label={t('birthdateLabel')}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                required
                sx={textFieldSx}
                fullWidth
                name="bday"
                type="text"
                error={!!profileData.birthDate.error}
                helperText={t(profileData.birthDate.error)}
              />
            );
          }}
        />
      </LocalizationProvider>
    </>
  );
};

export const textFieldSx: SxProps = {
  width: '100%',
  maxWidth: '30rem',
  display: 'block',
  marginBottom: '1rem',
};
